
// Terms.js

import React from 'react';

import LegalHeader from '../components/legalcomponents/LegalHeader';
import LegalContent from '../components/legalcomponents/LegalContent';

// See Privacy.js for more on this shape — LegalContent is generic, this
// array is what makes the page a Terms of Service instead of a Privacy
// Policy.
const sections = [
    {
        id: 'acceptance-of-terms',
        title: 'I. Scope and Acceptance of Terms',
        content: (
            <>
                <p>
                    These Website Terms of Use ("Terms") govern access to and use o
                    f the NicheWare website at NicheWare.ca (the "Website").
                </p>
                <p>
                    In these Terms, "NicheWare," "we," "our," and "us" refer to NicheWare Solutions, operating as NicheWare.
                </p>
                <p>
                    By accessing or using the Website, you acknowledge these Terms and agree to comply with them. 
                    If you do not agree with these Terms, you should not use the Website.
                </p>
                <p>
                    These Terms apply only to the public NicheWare Website. 
                    Software products, custom software development, support services, subscriptions, 
                    and other services provided to NicheWare clients may be governed by separate agreements.
                </p>
            </>
            
        ),
    },
    {
        id: 'use-of-our-website',
        title: 'II. Use of Our Website',
        content: (
            <>
                <p>
                   You may use the Website for lawful informational and business purposes.
                </p>

                <p>
                    You must not use the Website to:
                </p>

                <ul>
                    <li>violate any applicable law or regulation;</li>
                    <li>interfere with or disrupt the operation or security of the Website;</li>
                    <li>attempt to gain unauthorized access to the Website, its systems, or connected infrastructure;</li>
                    <li>introduce malicious code, automated attacks, spam, or other harmful material;</li>
                    <li>use automated tools to access or extract Website content in a manner that places an unreasonable burden on our systems;</li>
                    <li>impersonate another person or organization when communicating with NicheWare; or</li>
                    <li>use Website content in a way that infringes the intellectual property or other rights of NicheWare or another party.</li>
                </ul>

                <p>
                    We may restrict access to the Website where reasonably necessary to protect its security, 
                    availability, or lawful operation.
                </p>
            </>
        ),
    },
    {
        id: 'website-information',
        title: 'III. Website Information and No Client Relationship',
        content: (
            <>
                <p>
                    The Website provides general information about NicheWare, 
                    our products, previous work, and the types of software and services we may provide.
                </p>
                <p>
                    Website content is provided for general informational and promotional purposes and does not constitute
                    a binding proposal, quotation, service-level commitment, technical specification, 
                    warranty, or guarantee unless expressly incorporated into a separate written agreement with NicheWare.
                </p>
                <p>
                    Submitting a contact form, communicating with NicheWare, or discussing a potential project 
                    does not by itself create a client, partnership, employment, agency, or other contractual relationship.
                </p>
                <p>
                    Any software development project, subscription, implementation, support arrangement, 
                    or other commercial engagement with NicheWare will be subject to the terms agreed upon separately 
                    between NicheWare and the applicable client.
                </p>
            </>
        ),
    },
    {
        id: 'intellectual-property',
        title: 'IV. Intellectual Property',
        content: (
            <>
                <p>
                    Unless otherwise indicated, the Website and its original content, 
                    including its design, text, graphics, software, NicheWare branding, logos, and other materials 
                    created by or for NicheWare, are owned by NicheWare or used under licence and are protected by 
                    applicable intellectual property laws.
                </p>
                <p>
                    You may view and use Website content for ordinary personal or 
                    business informational purposes. You may not reproduce, distribute, modify, sell, 
                    republish, or commercially exploit NicheWare-owned Website content without our prior permission, 
                    except where permitted by law.
                </p>
                <p>
                    Third-party names, trademarks, logos, and other branding displayed on the Website remain 
                    the property of their respective owners. Their appearance on the Website does not transfer 
                    any ownership rights to NicheWare.
                </p>
            </>
        ),
    },
    {
        id: 'contact-form-user-communications',
        title: 'V. Contact Form and User Communications',
        content: (
            <>
                <p>
                    You may voluntarily provide information to NicheWare through our contact form or other communication channels.
                </p>
                <p>
                    Information submitted through the Website will be handled in accordance with our Privacy Policy.
                </p>
                <p>
                    By submitting an inquiry, you confirm that the information you provide is accurate to the best 
                    of your knowledge and that you have the right to provide that information.
                </p>
                <p>
                    Submitting an inquiry gives NicheWare permission to use the information provided as 
                    reasonably necessary to review and respond to the inquiry.
                </p>
                <p>
                    Submission of an inquiry does not obligate NicheWare to accept a project, 
                    provide services, enter into an agreement, or respond within any particular period of time.
                </p>
            </>
        ),
    },
    {
        id: 'privacy',
        title: 'VI. Privacy',
        content: (
            <>
                <p>
                    Our collection, use, disclosure, storage, and protection of personal information through 
                    the Website is described in our Privacy Policy.
                </p>
                <p>
                    The Privacy Policy forms a separate notice concerning our privacy practices 
                    and should be reviewed together with these Terms where you provide personal information through the Website.
                </p>
            </>
        ),
    },
    {
        id: 'third-party-websites',
        title: 'VII. Third-Party Websites and Services',
        content: (
            <>
                <p>
                    The Website may contain links to websites, services, or resources operated by third parties, 
                    including clients, partners, or service providers.
                </p>
                <p>
                    NicheWare does not control those third-party websites or services and is not responsible 
                    for their content, availability, security, privacy practices, or terms.
                </p>
                <p>
                    A link to or reference to a third party does not necessarily constitute an endorsement of all 
                    products, services, statements, or practices of that third party.
                </p>
                <p>
                    You are responsible for reviewing the terms and privacy practices 
                    applicable to third-party websites that you choose to visit.
                </p>
            </>
        ),
    },
    {
        id: 'website-availability',
        title: 'VIII. Website Availability and Changes',
        content: (
            <>
                <p>
                    We may modify, update, suspend, or discontinue any part of the Website from time to time.
                </p>
                <p>
                    We do not guarantee that the Website will always be available, uninterrupted, 
                    error-free, or free from temporary technical issues.
                </p>
                <p>
                    We may also update information about our products, services, clients, features, or 
                    other Website content as our business evolves.
                </p>
            </>
        ),
    },
    {
        id: 'disclaimer-of-warranties',
        title: 'IX. Disclaimer of Warranties',
        content: (
            <>
                <p>
                    To the extent permitted by applicable law, the Website and its content are provided on 
                    an "as is" and "as available" basis.
                </p>
                <p>
                    While we make reasonable efforts to keep Website information accurate and current, 
                    we do not warrant that all Website content will always be complete, accurate, current, uninterrupted, 
                    or error-free.
                </p>
                <p>
                    Nothing on the Website constitutes a warranty or guarantee regarding the performance, 
                    availability, capabilities, or suitability of a NicheWare product or service unless expressly stated 
                    in a separate written agreement.
                </p>
            </>
        ),
    },
    {
        id: 'limitation-of-liability',
        title: 'X. Limitation of Liability',
        content: (
            <>
                <p>
                    To the fullest extent permitted by law, NicheWare Solutions will not be liable for any indirect, 
                    incidental, or consequential damages arising from your use of our website.
                </p>
            </>
        ),
    },
    {
        id: 'governing-law',
        title: 'XI. Governing Law',
        content: (
            <>
                <p>
                    These Terms and your use of the Website are governed by the laws of the Province of Alberta 
                    and the federal laws of Canada applicable in Alberta, without regard to conflict-of-law principles.
                </p>
                <p>
                    Subject to applicable law, 
                    disputes relating to these Terms or use of the Website will be submitted to the courts of Alberta, Canada.
                </p>
            </>
        ),
    },
    {
        id: 'change-to-terms',
        title: 'XII. Change to These Terms',
        content: (
            <>
                <p>
                    We may update these Terms from time to time to reflect changes to our Website,
                    business practices, or legal requirements.
                </p>
                <p>
                   When we update these Terms, we will revise the "Last Updated" date shown at the top of this page.
                </p>
                <p>
                    Changes will apply from the effective date of the updated Terms.
                    Where appropriate or required by law, we may provide additional notice of material changes.
                </p>
            </>
        ),
    },
    {
        id: 'general-terms',
        title: 'XIII. General Terms',
        content: (
            <>
                <p>
                    If any provision of these Terms is found to be invalid or unenforceable, the remaining
                    provisions will continue to apply to the extent permitted by law.
                </p>
                <p>
                    Our failure to enforce a provision of these Terms does not constitute a waiver of that
                    provision or of our right to enforce it later.
                </p>
                <p>
                    These Terms constitute the terms governing use of the public Website but do not replace
                    or modify any separate written agreement between NicheWare and one of its clients.
                </p>
            </>
        ),
    },
    {
        id: 'contact-us',
        title: 'XIV. Contact Us',
        content: (
            <>
                <p>
                    If you have questions about these Terms of Use, you may contact NicheWare at:
                </p>
                <p>
                    <strong>NicheWare</strong><br/>
                    jeannicolasrouette@nicheware.ca<br/>
                    Calgary, Alberta, Canada
                </p>
                <p>
                    You may also contact us through our <a href="/contact">Contact page</a>.
                </p>
            </>
        ),
    },
];

const Terms = () => {

    return (
        <>
            <LegalHeader title="Website Terms of Service" lastUpdated="September 2026."/>

            <LegalContent sections={sections}/>
        </>

    )
}

export default Terms;
